import React from 'react'
import { observer, inject } from 'mobx-react'

import Grid from 'material-ui/Grid'
import StackGrid from 'react-stack-grid'
import Masonry from 'react-masonry-component'

import Card, { CardHeader, CardMedia, CardContent, CardActions } from 'material-ui/Card'
import Avatar from 'material-ui/Avatar'
import Typography from 'material-ui/Typography'
import Icon from 'material-ui/Icon'
import IconButton from 'material-ui/IconButton'
import T from 'i18n-react'
import ButtonBase from 'material-ui/ButtonBase'
import { Link } from 'react-router-dom'
import Tooltip from 'material-ui/Tooltip'
import Button from 'material-ui/Button'
import { AddToCartButton,AddCollectionToCartButton } from './cart'
import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog'
import Slide from 'material-ui/transitions/Slide'
import Waypoint from 'react-waypoint'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui/styles'
import Badge from 'material-ui/Badge'
import { CircularProgress } from 'material-ui/Progress'
import Explanation from './explanation'


@inject('store','ui') @observer
class Catalog extends React.Component {
  render () {
    const { store,ui,classes } = this.props

    return (
      <div>

       {store.items.length > 0 &&
        <Button raised dense disabled className={classes.catalogItemCounter} color="secondary">{store.items.length}</Button>
       }

       {store.items.length === 0 && <NoMatches />}

       {store.loadingCatalogItems &&
        <CircularProgress className="center-center" size={50} />
       }

       <Masonry options={{transitionDuration: 250}}>

        {store.items.map( (item,index) => {
         return <CatalogItem key={index} item={item} itemWidth={ui.catalog.itemWidth} />
        })}

       </Masonry>


       {store.moreCatalogContentToLoad && store.items.length > 0 &&
         <Button
          onClick={store.loadMoreResults}
          className={classes.loadMoreButton}
          fullWidth
         >
          {store.loadingCatalogItems && <CircularProgress size={24} />}
          {T.translate('meta.loadMore')}
         </Button>
       }

       {store.isAuthorized && <DeleteItemDialog />}

       {!ui.catalog.loadedPopupOnce && <Explanation />}

      </div>
    )
  }

  componentWillMount () {
    //this.props.store.search()
  }

  componentDidMount () {
    const setWindowWidth = this.props.ui.catalog.setWindowWidth

    window.addEventListener('resize',setWindowWidth)
    window.addEventListener('orientationchange',setWindowWidth)

    this.props.ui.search.updateLayout()
  }

  componentWillUnmount () {
    this.props.ui.catalog.loadedPopupOnce = true
  }
}

class NoMatches extends React.Component {
  render () {
    return (
      <div className="center-center">
        <Typography type="headline"> {T.translate('search.noMatches')} </Typography>
        <div className="sheep">
          <span className="top">
            <div className="body"></div>
            <div className="head">
              <div className="eye one"></div>
              <div className="eye two"></div>
              <div className="ear one"></div>
              <div className="ear two"></div>
            </div>
          </span>
            <div className="legs">
              <div className="leg"></div>
              <div className="leg"></div>
              <div className="leg"></div>
              <div className="leg"></div>
          </div>
        </div>
      </div>
    )
  }
}

@inject('store','ui') @observer
export class CatalogItem extends React.Component {
  render () {
    const { store, item, itemWidth } = this.props
    let pathname = "", cardheader = null

    let addToCartButton = null
    if (item.isExample) {
      addToCartButton = <AddToCartButton atCatalogView={true} item={item} />
      pathname = store.getItemTitleAsURLString(item.id,item.title)
      cardheader = <CardHeader title={item.title} />
    } else {
      addToCartButton = <AddCollectionToCartButton atCatalogView={true} collection={item} />
      pathname = store.getCollectionLink(item.id)
      cardheader = <CardHeader
                    avatar={<Avatar aria-label="Recipe"> {store.getBeispielTypFirstChar(item.type.name)} </Avatar>}
                    title={item.title}
                    subheader={item.type.name}
                   />
    }

    const image = store.getItemImage(item)

    return (
       <div style={{padding:5,width:itemWidth}}>
        <Card>

         {cardheader}
         {addToCartButton}

         <Link to={ pathname } className="unstyle-a">
          <CardMedia className="catalog-item-media"
           image={image}
           title={item.title}
          />

          <CardContent className="rel">
           <Typography component="p">
            {item.description}
            <span className="catalog-item-text-fade" />
           </Typography>
          </CardContent>
         </Link>

         <CardActions disableActionSpacing className="catalog-item-actions">

          <Grid container spacing={0}>
           <Grid item xs={4} className="center-flex">
            {item.zyklus1 && <Tooltip id="tooltip-icon" title={T.translate("meta.cycle") + "1"} placement="top"><Avatar className="catalog-item-zyklus-avatar catalog-item-color-zyklus-1">1</Avatar></Tooltip>}
            {item.zyklus2 && <Tooltip id="tooltip-icon" title={T.translate("meta.cycle") + "2"} placement="top"><Avatar className="catalog-item-zyklus-avatar catalog-item-color-zyklus-2">2</Avatar></Tooltip>}
            {item.zyklus3 && <Tooltip id="tooltip-icon" title={T.translate("meta.cycle") + "3"} placement="top"><Avatar className="catalog-item-zyklus-avatar catalog-item-color-zyklus-3">3</Avatar></Tooltip>}
           </Grid>
           <Grid item xs={4} className="center-flex">
            {item.isExample &&
             <Tooltip id="tooltip-icon" title={item.type.name} placement="top">
              <Avatar className="catalog-search-avatar"> {store.getBeispielTypFirstChar(item.type.name)} </Avatar>
             </Tooltip>
            }
           </Grid>
           <Grid item xs={4} className="catalog-item-lessons center-flex">
            <Typography> {store.getApproximatedTimevalue(item)} </Typography>
           </Grid>
          </Grid>

         </CardActions>
         {store.isAuthorized &&
           <CardActions disableActionSpacing className="catalog-item-actions-sudo">
            <Button dense color="secondary" onClick={this.openEditDialog.bind(this,item)}>
             {T.translate("meta.edit")}
            </Button>
            <Button dense color="secondary" onClick={this.openDeleteDialog.bind(this,item)}>
             {T.translate("meta.remove")}
            </Button>
           </CardActions>
         }

        </Card>
       </div>
    )
  }

  openDeleteDialog (item) {
   if (item.isExample) {
     this.props.store.setCurrentExample(item)
     this.props.store.deletePointer = this.props.store.exampleForm.currentExample
     this.props.ui.catalog.handleOpenDeleteDialog()
   }
   else if (item.isCollection) {
    this.props.store.setCurrentCollection(item)
    this.props.store.deletePointer = this.props.store.collectionForm.currentCollection
    this.props.ui.catalog.handleOpenDeleteDialog()
   }
  }

  openEditDialog (item) {
   if (item.isExample) {
     this.props.store.setCurrentExample(item)
     this.props.store.setExampleFormAsUpdate()
     this.props.ui.newExampleForm.handleOpen()
   }
   else if (item.isCollection) {
     this.props.store.setCurrentCollection(item)
     this.props.store.setCollectionFormAsUpdate()
     this.props.ui.newCollectionForm.handleOpen()
   }

  }

}


@inject('store','ui','messenger') @observer
export class DeleteItemDialog extends React.Component {
  render () {
    const ui = this.props.ui.catalog,
          item = this.props.store.deletePointer,
          title = item ? item.title : "",
          store = this.props.store

    return (
      <Dialog
       open={ui.openDeleteDialog}
       keepMounted
       onClose={ui.handleCloseDeleteDialog}
      >

        <DialogContent>
         <DialogContentText> <b>{title}</b> {T.translate("admin.catalog.deleteDialogText")} </DialogContentText>
        </DialogContent>
        <DialogActions>
         <Button onClick={ui.handleCloseDeleteDialog} color="primary">
          {T.translate("meta.close")}
         </Button>
         <Button onClick={this.deleteItem} color="secondary">
          {T.translate("meta.delete")}
         </Button>
        </DialogActions>

      </Dialog>
    )
  }

  deleteItem = () => {
   const item = this.props.store.deletePointer
   this.props.store.sudoDelete(item, (res) => {
     this.props.messenger.handleOpen(this.props.messenger.messages.ITEM_DELETED)
     this.props.ui.catalog.handleCloseDeleteDialog()
   })
  }

}

const styles = theme => ({
  catalogItemCounter: {
   position:'fixed',
   top:141,
   right:-20,
   zIndex:20,
   justifyContent:'flex-start',
   color:'#fff'
  },
  loadMoreButton:{
   'margin-top':10,
   'margin-bottom':60
  }
})



export default withStyles(styles, { withTheme: true })(Catalog)



// WEBPACK FOOTER //
// ./src/components/catalog.js